import { AsyncPipe, CommonModule } from '@angular/common';
import { CurrencyPipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';

import { map } from 'rxjs/operators';

import { of } from 'rxjs';

import { TranslatePipe } from '@camelot/translation';
import { CamPermissionsService, CamUsersService, User } from '@camelot/user';
import { CamBaseComponent } from '@camelot/utils';

import { CamTranslationProject } from '../../../../translation.service';
import { IPrice } from '../../helpers/price';

export type Display = 'label' | 'amount' | 'both';

@Component({
  selector: 'cam-billing-amount',
  templateUrl: './amount.component.html',
  styleUrl: './amount.component.scss',
  imports: [AsyncPipe, CurrencyPipe, CommonModule, TranslatePipe],
})
export class CamAmountComponent extends CamBaseComponent {
  amount = input<IPrice>();

  display = input<Display>('both');

  inverse = input(false);

  forceTTC = input(false);

  public readonly _permissionsService = inject(CamPermissionsService);

  constructor() {
    super();
    CamTranslationProject.getInstance();
  }

  private _userService = inject(CamUsersService);

  get label$() {
    if (!this._permissionsService.isAuthenticated) {
      return of('project.billings.amount.label.tva');
    }
    return this._userService.currentUser
      .get$()
      .pipe(
        map(user => (this._hideTva(user) ? 'project.billings.amount.label.htva' : 'project.billings.amount.label.tva'))
      );
  }
  get amount$() {
    if (!this._permissionsService.isAuthenticated) {
      return of(this.amount()?.incl);
    }
    return this._userService.currentUser
      .get$()
      .pipe(map(user => (this._hideTva(user) ? this.amount()?.excl : this.amount()?.incl)));
  }

  private _hideTva(user: User | null) {
    const isCompany = this.forceTTC() ? user?.isCompany : false;

    return this.inverse() ? !isCompany : isCompany;
  }
}
